import { render, staticRenderFns } from "./SkeletonPreloader.vue?vue&type=template&id=ada8dc92&scoped=true"
import script from "./SkeletonPreloader.vue?vue&type=script&lang=ts"
export * from "./SkeletonPreloader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada8dc92",
  null
  
)

export default component.exports